import * as React from 'react';
import { getFormattedAmount } from 'frontend-toolkit';
import { capitalize } from 'core/utils';
import { convertFromPennies } from 'core/utils';

const InstallmentRowReadOnly = ({
  amount,
  status,
}: {
  amount: number;
  status: string;
}) => (
  <li className="sui-pb-1">
    <div
      className="sui-flex sui-gap-1 sui-bg-neutral-background-weak sui-p-1 sui-items-baseline sui-w-20/24"
      style={{ width: '69%' }}
    >
      <div className="sui-w-5/12 sui-grow-0">
        {getFormattedAmount(convertFromPennies(amount))}
      </div>
      <div className="sui-caption">{capitalize(status?.replace('_', ' '))}</div>
    </div>
  </li>
);

export default InstallmentRowReadOnly;
